import * as React from "react";
import type { SVGProps } from "react";

interface MainProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Main = ({ cancelled = false, ...props }: MainProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={66}
    height={66}
    viewBox="0 0 66 66"
    {...props}
  >
    <g>
    <defs>
      <ellipse id="a" cx={14.605} cy={14.605} rx={11.751} ry={8.903} />
      <ellipse id="c" cx={14.605} cy={14.605} rx={11.751} ry={8.903} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="matrix(-1 0 0 1 61.882 2)">
        <path
          fill="#FFF"
          fillRule="nonzero"
          stroke="#FFF"
          strokeLinejoin="round"
          strokeWidth={2.5}
          d="m25.041 21.247 3.758 3.458 8.585 7.897 4.93 2.217 17.17 15.795-6.125 6.705-17.2-15.823-2.483-5.076-8.232-7.572-4.236-3.897zM5.425 5.397c2-2.007 4.872-2.8 7.93-2.376 2.878.398 5.917 1.884 8.419 4.395 2.5 2.51 3.98 5.558 4.378 8.445.42 3.066-.369 5.945-2.367 7.95-2 2.008-4.873 2.8-7.93 2.377-2.878-.398-5.918-1.884-8.42-4.395-2.5-2.51-3.98-5.558-4.377-8.445-.421-3.065.368-5.945 2.367-7.95Z"
        />
        <path
          fill="#FFF"
          fillRule="nonzero"
          stroke="#FFF"
          strokeLinejoin="round"
          strokeWidth={2.5}
          d="m33.878 21.247-3.759 3.458-8.584 7.897-4.93 2.217-17.17 15.795 6.125 6.705 17.2-15.823 2.483-5.076 8.232-7.572 4.235-3.897zm19.616-15.85c-2-2.007-4.872-2.8-7.93-2.376-2.878.398-5.917 1.884-8.42 4.395-2.5 2.51-3.98 5.558-4.377 8.445-.421 3.066.369 5.945 2.367 7.95 2 2.008 4.872 2.8 7.93 2.377 2.878-.398 5.917-1.884 8.42-4.395 2.5-2.51 3.98-5.558 4.377-8.445.421-3.065-.368-5.945-2.367-7.95Z"
        />
        <ellipse
          cx={14.605}
          cy={14.605}
          stroke="#000"
          strokeWidth={1.575}
          rx={12.539}
          ry={9.69}
          transform="rotate(-135 14.605 14.605)"
        />
        <path
          fill="#999"
          fillRule="nonzero"
          d="m25.062 22.965 2.891 2.66L46.623 42.8l-1.902 2.082-18.43-16.955-3.26-3z"
        />
        <path
          fill="#007BBD"
          fillRule="nonzero"
          d="M37.178 40.735 34.51 35.28l1.578-1.889 5.53 2.485L57.72 50.69l-4.44 4.86z"
        />
        <path
          stroke="#000"
          strokeLinejoin="round"
          strokeWidth={1.575}
          d="m25.062 22.965 2.891 2.66 8.733 8.034 4.931 2.217L57.721 50.69l-4.44 4.86-16.103-14.815-2.483-5.076-8.405-7.731-3.26-3z"
        />
        <g>
          <mask id="b" fill="#fff">
            <use xlinkHref="#a" transform="rotate(-135 14.605 14.605)" />
          </mask>
          <path
            stroke="#CFCFCF"
            strokeLinecap="square"
            strokeWidth={0.851}
            d="m9.422-1.593 23.291 23.29M4.627 3.203l23.291 23.29M-.168 7.997l23.291 23.292M7.024.804l23.292 23.291M2.23 5.6 25.52 28.89M-2.564 10.394l23.29 23.291m11.992-23.29L9.427 33.686M27.921 5.6 4.632 28.89M23.127.805-.164 24.096M30.32 7.997 7.029 31.29M25.525 3.202 2.234 26.494M20.73-1.592-2.56 21.698M17.906-3.477l-23.29 23.291"
            mask="url(#b)"
          />
        </g>
      </g>
      <g transform="translate(3.118 2)">
        <ellipse
          cx={14.605}
          cy={14.605}
          stroke="#000"
          strokeWidth={1.575}
          rx={12.539}
          ry={9.69}
          transform="rotate(-135 14.605 14.605)"
        />
        <path
          fill="#999"
          fillRule="nonzero"
          d="m25.062 22.965 2.891 2.66L46.623 42.8l-1.902 2.082-18.43-16.955-3.26-3z"
        />
        <path
          fill="#007BBD"
          fillRule="nonzero"
          d="M37.178 40.735 34.51 35.28l1.578-1.889 5.53 2.485L57.72 50.69l-4.44 4.86z"
        />
        <path
          stroke="#000"
          strokeLinejoin="round"
          strokeWidth={1.575}
          d="m25.062 22.965 2.891 2.66 8.733 8.034 4.931 2.217L57.721 50.69l-4.44 4.86-16.103-14.815-2.483-5.076-8.405-7.731-3.26-3z"
        />
        <g>
          <mask id="d" fill="#fff">
            <use xlinkHref="#c" transform="rotate(-135 14.605 14.605)" />
          </mask>
          <path
            stroke="#CFCFCF"
            strokeLinecap="square"
            strokeWidth={0.851}
            d="m9.422-1.593 23.291 23.29M4.627 3.203l23.291 23.29M-.168 7.997l23.291 23.292M7.024.804l23.292 23.291M2.23 5.6 25.52 28.89M-2.564 10.394l23.29 23.291m11.992-23.29L9.427 33.686M27.921 5.6 4.632 28.89M23.127.805-.164 24.096M30.32 7.997 7.029 31.29M25.525 3.202 2.234 26.494M20.73-1.592-2.56 21.698M17.906-3.477l-23.29 23.291"
            mask="url(#d)"
          />
        </g>
      </g>
      <g fillRule="nonzero">
        <path
          fill="#FFF"
          stroke="#FFF"
          strokeWidth={1.5}
          d="M33.237 40.84a4.38 4.38 0 0 1 3.361.694 4.54 4.54 0 0 1 1.885 2.797c.235 1.1.05 2.274-.61 3.266-.391.587-.887 1.015-1.456 1.276l-.586.826-2.464 14.041-.653.481c-.988.728-1.71.987-2.552.827a3.9 3.9 0 0 1-1.503-.648c-.731.062-1.053.069-1.341.027a4.7 4.7 0 0 1-2.028-.985c-.959-.091-1.696-.289-2.323-.645-.855-.56-1.34-1.11-1.706-1.774-.805-.48-1.26-.782-1.608-1.166-.539-.696-.765-1.3-.843-1.989-.711-.504-1.131-.897-1.436-1.291-.423-.617-.57-1.167-.56-1.702.014-.62.254-1.232.661-1.857l11.86-7.709.564-.806c.019-.61.182-1.152.483-1.67.737-1.117 1.762-1.769 2.855-1.993Z"
        />
        <path
          fill="#000"
          d="m35.19 49.45-5.324-3.591-11.69 7.445-.155.254c-.514.843-.676 1.649-.18 2.387l.125.172c.31.401.76.794 1.355 1.2l.21.138c.027.697.195 1.272.543 1.735l.136.165c.334.37.79.644 1.367.849l.138.044.11.238c.323.645.751 1.158 1.294 1.524l.218.135c.596.338 1.308.5 2.127.506l.055-.002.071.065c.56.488 1.117.807 1.692.943l.145.028c.288.042.614.018 1.025-.066l.323-.074.1.084c.454.354.927.587 1.428.682.66.126 1.21-.136 1.966-.694l.41-.302zm-1.382.597-2.273 12.555q-.707.522-.983.468-.68-.13-1.42-.929-1.218.365-1.549.287-.705-.166-1.57-1.06-1.41.115-2.185-.41-.777-.522-1.159-1.76-1.206-.269-1.589-.777-.382-.508-.272-1.666-1.477-.863-1.923-1.526-.22-.326.205-1.02l10.743-6.843z"
        />
        <path
          fill="#000"
          d="M34.145 49.015 32.8 53.06l.291.098.895.284-.315.977-.484-.153a32 32 0 0 1-.71-.232l-2.953 8.903-1.191-.386 2.968-8.95q-.223-.09-.43-.18l-4.481 9.096-1.125-.549 4.48-9.098a7 7 0 0 1-.72-.464l-6.318 7.804-.97-.79 6.33-7.821a17 17 0 0 1-.442-.43l-6.855 6.48-.855-.914 6.855-6.478q-.186-.21-.379-.432l-.608-.718.78-.667.327.388q.323.384.626.723l2.914-2.757.817.874.078-.094.95.772.664.324.013-.04zm-2.687.382-1.786 2.21a6 6 0 0 0 .53.34zm-.465-1.413-2.62 2.48q.176.177.344.336zm1.386 2.376-1.055 2.139q.147.063.302.126z"
        />
        <path
          fill="#000"
          d="m37 47.047-5.63-3.85-2.334 3.507.54.723c.584.78 1.197 1.396 1.849 1.842.652.445 1.445.791 2.377 1.047l.864.237z"
        />
        <path
          fill="#FFF"
          d="m35.263 47.389-1.134 1.703q-1.212-.332-2.005-.874-.794-.543-1.55-1.556l1.133-1.704z"
        />
        <path
          fill="#000"
          d="M36.31 41.928c-1.787-1.222-4.198-.818-5.376.952-1.19 1.789-.392 3.586 1.497 4.877 1.888 1.292 3.832 1.368 5.022-.42 1.178-1.77.645-4.187-1.143-5.41"
        />
        <path
          fill="#FFF"
          d="M35.61 42.979c1.228.839 1.589 2.473.806 3.649s-2.058.917-3.286.078c-1.227-.839-1.941-1.94-1.159-3.117.783-1.176 2.412-1.45 3.64-.61"
        />
      </g>
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Main;
